export enum EAttachmentUploadResults {
  SUCCESS = 'Attachment successfully uploaded',
}

export enum EAttachmentType {
  GENERAL_PROJECT_ATTACHMENT = 'GENERAL_PROJECT_ATTACHMENT',
  SYNC_CLIENT_REQUEST = 'SYNC_CLIENT_REQUEST',
  APPROVAL_DOCUMENT = 'APPROVAL_DOCUMENT',
  QUOTE_ISSUED = 'QUOTE_ISSUED',
  LICENSE_REQUEST = 'LICENSE_REQUEST',
  LICENSE = 'LICENSE',
  LICENSE_AND_INVOICE_SENT = 'LICENSE_AND_INVOICE_SENT',
  INVOICE = 'INVOICE',
  PARTIALLY_EXECUTED_AGREEMENT = 'PARTIALLY_EXECUTED_AGREEMENT',
  FULLY_EXECUTED_AGREEMENT = 'FULLY_EXECUTED_AGREEMENT',
  REVISION_CORRESPONDENCE = 'REVISION_CORRESPONDENCE',
  INTERNAL_CORRESPONDENCE = 'INTERNAL_CORRESPONDENCE',
  PAYMENT_CORRESPONDENCE = 'PAYMENT_CORRESPONDENCE',
  PAYMENT = 'PAYMENT',
  CUE_SHEET = 'CUE_SHEET',
  SCRIPT = 'SCRIPT',
  FULL_TRACK_LIST = 'FULL_TRACK_LIST',
  OTHER_MEMO = 'OTHER_MEMO',
  PITCH = 'PITCH',
  BRIEF = 'BRIEF',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  DEAL_MEMO = 'DEAL_MEMO',
}

export const ATTACHMENT_TYPE: { [key in EAttachmentType]: string } = {
  [EAttachmentType.GENERAL_PROJECT_ATTACHMENT]: 'General Project Attachment',
  [EAttachmentType.SYNC_CLIENT_REQUEST]: 'Sync Client Request',
  [EAttachmentType.APPROVAL_DOCUMENT]: 'Approval Document',
  [EAttachmentType.QUOTE_ISSUED]: 'Quote Issued',
  [EAttachmentType.LICENSE_REQUEST]: 'License Request',
  [EAttachmentType.LICENSE]: 'License',
  [EAttachmentType.LICENSE_AND_INVOICE_SENT]: 'License & Invoice Sent',
  [EAttachmentType.INVOICE]: 'Invoice',
  [EAttachmentType.PARTIALLY_EXECUTED_AGREEMENT]: 'Partially Executed Agreement',
  [EAttachmentType.FULLY_EXECUTED_AGREEMENT]: 'Fully Executed Agreement',
  [EAttachmentType.REVISION_CORRESPONDENCE]: 'Revision Correspondence',
  [EAttachmentType.INTERNAL_CORRESPONDENCE]: 'Internal Correspondence',
  [EAttachmentType.PAYMENT_CORRESPONDENCE]: 'Payment Correspondence',
  [EAttachmentType.PAYMENT]: 'Payment',
  [EAttachmentType.CUE_SHEET]: 'Cue Sheet',
  [EAttachmentType.SCRIPT]: 'Script',
  [EAttachmentType.FULL_TRACK_LIST]: 'Full Track List',
  [EAttachmentType.OTHER_MEMO]: 'Other Memo',
  [EAttachmentType.PITCH]: 'Pitch',
  [EAttachmentType.BRIEF]: 'Brief',
  [EAttachmentType.PURCHASE_ORDER]: 'Purchase Order',
  [EAttachmentType.DEAL_MEMO]: 'Deal Memo',
};

export enum EAttachmentsGridColumns {
  CATEGORY = 'category',
  DETAILS = 'details',
  ATTACHMENT = 'attachment',
  FILE_NAME = 'fileName',
  ACTORS = 'actors',
  DATE_TIME = 'date',
}

export enum EAttachmentsSortDirection {
  ASCENDING = 'ASC',
  DESCENDING = 'DESC',
}

export enum EAttachmentsQueryFields {
  TYPE = 'TYPE',
  DETAILS = 'DETAILS',
  NOTES = 'NOTES',
  USER = 'USER',
  SORT_DIRECTION = 'sortDirection',
  SORT_FIELD = 'sortField',
}

export enum EAttachmentsPreviewAvailableFormats {
  TIFF = 'TIFF',
  GIF = 'GIF',
  BMP = 'BMP',
  PNG = 'PNG',
  JPG = 'JPG',
  PDF = 'PDF',
  DOC = 'DOC',
  DOCX = 'DOCX',
  TXT = 'TXT',
  RTF = 'RTF',
  XLS = 'XLS',
  XLSX = 'XLSX',
  CSV = 'CSV',
  MSG = 'MSG',
  ZIP = 'ZIP',
  EML = 'EML',
}

export enum EAttachmentsFilterTypes {
  TAG_SELECTOR = 'TAG_SELECTOR',
  STRING_INPUT = 'STRING_INPUT',
}

export enum EAttachmentsSortingColumns {
  DATE = 'CREATED_DATE',
  LABEL = 'ATTACHMENT_LABEL',
}

export enum EAttachmentsDisableTypes {
  // eslint-disable-next-line max-len
  BULK_EDIT = 'You cannot BULK EDIT Attachments when an External Attachment is selected. Please edit External Attachments in their own Projects. (Click on the Project ID below to link to the Project.)',
  // eslint-disable-next-line max-len
  BULK_DELETE = 'You cannot BULK DELETE Attachments when an External Attachment is selected. Please delete External Attachments in their own Projects. (Click on the Project ID below to link to the Project.)',
  DELETE = 'Please delete External Attachments in their own project by clicking its project ID.',
  EDIT = 'Please edit External Attachments in their own project by clicking its project ID.',
}
